let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3Yes2")).then(() => parcelRequire('lQRJL'));